import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
}

const FormDialog: React.FC<FormDialogProps> = ({ formMode }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] gap-y-4 overflow-y-auto p-4'>
      <div className='flex items-center'>
        <Label className='min-w-40'>Mã phương thức</Label>
        <FormField
          type='text'
          className='w-full'
          name='ma_ptgh'
          disabled={formMode === 'view' || formMode === 'edit'}
        />
      </div>

      <div className='flex items-center'>
        <Label className='min-w-40'>Tên phương thức</Label>
        <FormField type='text' name='ten_ptgh' className='w-full' disabled={isViewMode} />
      </div>

      <div className='flex items-center'>
        <Label className='min-w-40'>Tên khác</Label>
        <FormField type='text' name='ten_ptgh2' disabled={isViewMode} />
      </div>

      <div className='flex items-center'>
        <Label htmlFor='status' className='min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Còn sử dụng' },
            { value: '0', label: '0. Không sử dụng' }
          ]}
        />
      </div>
    </div>
  );
};

export default FormDialog;
